import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getEmailTemplates = createAsyncThunk(
  "emailTemplate/getEmailTemplates",
  async ({ search = "", filter = "" }, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/email-template?search=${search}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get emailTemplate.");
    }
  }
);

export const addEmailTemplate = createAsyncThunk(
  "emailTemplate/addEmailTemplate",
  async (data, { rejectWithValue }) => {
    try {

      let url = "admin/email-template";
      if (data.id) {
        url += `/${data.id}`;
      }
      const response = await api.post(url, data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add emailTemplate");
    }
  }
);

export const deleteEmailTemplate = createAsyncThunk(
  "emailTemplate/deleteEmailTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/email-template/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete emailTemplate");
    }
  }
);

const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState: {
    list_email_template: [],
    selected: null,
    loading: false,
    list_loading: false,
    status: "idle",
  },
  reducers: {
    setSelectedEmailTemplate(state, action) {
      state.selected = action.payload;
    },
    unsetSelectedEmailTemplate(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.loading = false,
      state.list_loading = false
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getEmailTemplates.pending, (state) => {
      state.list_loading = true;
    })
    .addCase(getEmailTemplates.fulfilled, (state, action) => {
      state.list_loading = false;
      state.list_email_template = action.payload;
    })
    .addCase(getEmailTemplates.rejected, (state) => {
      state.list_loading = false;
    })
    .addCase(addEmailTemplate.pending, (state) => {
      state.loading = true;
    })
    .addCase(addEmailTemplate.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(addEmailTemplate.rejected, (state) => {
      state.loading = false;
    })
    .addCase(deleteEmailTemplate.pending, (state) => {
      state.loading = true;
    })
    .addCase(deleteEmailTemplate.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(deleteEmailTemplate.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setSelectedEmailTemplate, unsetSelectedEmailTemplate, resetStatus } = emailTemplateSlice.actions;
export default emailTemplateSlice.reducer;
